import { createAction } from "@reduxjs/toolkit";
import { UpdateSchemaItem } from "../../reducers/schema/schema";

export const openModelModalAction = createAction('openModelModalAction');
export const openEditSchemaAction = createAction<string>('openEditSchemaAction');
export const addStructureItem = createAction('addStructureItem');
export const removeStructureItem = createAction<number>('removeStructureItem');
export const updateStructureItem = createAction<UpdateSchemaItem>('updateStructureItem');
export const closeModelModalAction = createAction('closeModelModalAction');

